import axios from 'axios'
import { getCookie, removeCookie } from './cookieFunctions'
import { oturumYenile, tekrar } from '../api/auth'

let isRefresing = false

const wait = (seconds) =>
  new Promise(resolve =>
    setTimeout(() =>
      resolve(true), seconds * 1000))
const service = axios.create(
  {
    baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000/api/' : window.location.origin + '/api/',
    timeout: process.env.NODE_ENV === 'development' ? 0 : 15000,
    withCredentials: true
  })

const messageContainsHttpMethods = ['put', 'delete', 'post']

service.interceptors.request.use(
  async config => {
    config.headers.post['Content-Type'] = 'application/json multipart/form-data'
    if (getCookie('token')) {
      config.headers.common.Authorization = 'Bearer ' + getCookie('token')
    }
    if ((config.url.indexOf('rapor') !== -1 || config.url.indexOf('Rapor') !== -1) && process.env.NODE_ENV !== 'development') {
      config.timeout = 100000
    }
    if (config.url.indexOf('sinifa-uygun-hocalar') !== -1) {
      config.timeout = 60000
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.config.url === 'rapor/excel-ogrenci-rapor' || response.config.url === 'rapor/excel-sinif-rapor' ||
      response.config.url === 'rapor/excel-kisi-rapor' || response.config.url === 'rapor/excel-ogrenci-detayli-rapor') {
      return Promise.resolve(response)
    } else {
      /* const verssion = getCookie('frontend-version')
      if (!verssion) {
        setHoursCookie('frontend-version', response.data.version, 8760)
        location.reload()
      }
      if (response.data.version !== verssion) {
        setHoursCookie('frontend-version', response.data.version, 8760)
        location.reload()
      } */
      if (response.status === 200 && messageContainsHttpMethods.includes(response.config.method) && response.data?.data) {
        window.lokum.$bvToast.toast(response.data.data, {
          title: 'Başarı',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true
        })
      }
      return Promise.resolve(response.data)
    }
  },
  async error => {
    if (error.response) {
      const { status: statusKod } = error.response
      if (statusKod === 401) {
        // yenilenmiş token ile de 401 gelirse tekrar denenmez, oturum kapatılır.
        // önceden sınırsız tekrar deneniyordu ve sayfa açık kaldıkça saniyede bir istek atılıyordu
        if (error.config._tekrarDenendi) {
          Sil()
          location.reload()
          return Promise.reject(error.response)
        }
        error.config._tekrarDenendi = true
        if (isRefresing) {
          // başka bir istek oturumu yeniliyor, bitmesini bekle
          // eslint-disable-next-line no-unmodified-loop-condition
          while (isRefresing) {
            await wait(1)
          }
        } else {
          isRefresing = true
          try {
            await oturumYenile(getCookie('refreshToken'))
          } catch (e) {
            // e yoksa timeout/bağlantı hatasıdır, oturum kapatılmaz
            if (e) {
              Sil()
              location.reload()
            }
            return Promise.reject(error.response)
          } finally {
            // hata ne olursa olsun bayrak sıfırlanır; önceden catch içinde hata alınca
            // true kalıyor ve sonraki tüm 401'ler süresi dolmuş token ile sonsuza kadar tekrarlanıyordu
            isRefresing = false
          }
        }
        error.config.headers.Authorization = 'Bearer ' + getCookie('token')
        return tekrar(error.config)
      } else if (statusKod === 400) {
        if (error.response && error.response.data && error.response.data.message) {
          window.lokum.$bvToast.toast(error.response.data.message, {
            title: 'Hata',
            autoHideDelay: 5000,
            variant: 'danger',
            solid: true
          })
        }
      } else if (statusKod === 403) {
        if (error.response && error.response.data && error.response.data.message) {
          window.lokum.$bvToast.toast(error.response.data.message, {
            title: 'Hata',
            autoHideDelay: 5000,
            variant: 'danger',
            solid: true
          })
          window.lokum.$router.push('/anasayfa')
        }
      } else if (statusKod === 404) {
        window.lokum.$bvToast.toast('Bu Modül Henüz Aktifleştirilmemiş', {
          title: 'Hata',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true
        })
      } else if (statusKod >= 500) {
        window.lokum.$bvToast.toast('Sunucu Hatası Oluştu', {
          title: 'Hata',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true
        })
      } else {
        window.lokum.$bvToast.toast('Bilinmeyen Bir Hata Oluştu', {
          title: 'Hata',
          autoHideDelay: 5000,
          variant: 'danger',
          solid: true
        })
      }
    } else {
      window.lokum.$bvToast.toast('İletişim Hatası Oluştu', {
        title: 'Hata',
        autoHideDelay: 5000,
        variant: 'danger',
        solid: true
      })
    }
    return Promise.reject(error.response)
  }
)

function Sil () {
  removeCookie('token')
  removeCookie('refreshToken')
}

export default service
